// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const PayrollImportPage = lazy(() => import('./pages/PayrollImportPage'));
const AccrualsPage = lazy(() => import('./pages/AccrualsPage'));
const WageAllocationPage = lazy(() => import('./pages/WageAllocationPage'));

export const PayrollLinkRoutes: RouteObject = {
  path: 'payroll-link',
  element: <ModuleGuard moduleId="finance.payroll-link" />,
  children: [
    { path: 'payroll-import', element: <PayrollImportPage />, handle: { crumb: 'Payroll Import' } },
    { path: 'accruals', element: <AccrualsPage />, handle: { crumb: 'Accruals' } },
    { path: 'wage-allocation', element: <WageAllocationPage />, handle: { crumb: 'Wage Allocation' } },
  ],
};
